/** @jsxImportSource @emotion/react */
import { useParams } from "react-router";
import { Divider } from "../../../../components/Divider";
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { useGetBalanceAccount } from "../../service/adyen-account-holders-api";
import { SpinnerBlock } from "../../../common/Spinner";
import { AdyenBalanceAccountDetails } from "../components/AdyenBalanceAccountDetails";

export const InspectBalanceAccountPage = () => {
  const { balanceAccountId } = useParams();

  const { data: balanceAccount, isLoading } = useGetBalanceAccount(
    balanceAccountId
  );

  return (
    <RouteFullScreenModal title="Balance account details">
      <Divider />
      {isLoading || !balanceAccount ? (
        <SpinnerBlock />
      ) : (
        <AdyenBalanceAccountDetails balanceAccount={balanceAccount} />
      )}
    </RouteFullScreenModal>
  );
};
